import {QueryRequestActionPlans} from './core/QueryRequestProvider'
import {QueryResponseActionPlans} from './core/QueryResponseProvider'
import {ActionPlansTable} from './table/ActionPlansTable'

const ActionPlansListWrapper = (uuid: any) => {
  // const {itemIdForUpdate} = useListView()
  const uuidRow: string = uuid.uuid
  const project_id: string = uuid.project_id
  console.log(project_id)
  return (
    <>
      <QueryRequestActionPlans>
        <QueryResponseActionPlans uuid={uuidRow}>
          <ActionPlansTable uuid={uuidRow} project_id={project_id} />
        </QueryResponseActionPlans>
      </QueryRequestActionPlans>
      {/* {itemIdForUpdate !== undefined} */}
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

export {ActionPlansListWrapper}
